import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { startLogout } from '../../store/auth';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';
import { ModalCambiarPassword } from './ModalCambiarPassword';
import UserIcon from '../../assets/images/UserIcon';
import LogoutIcon from '../../assets/images/LogoutIcon';
import PasswordModifyIcon from '../../assets/images/PasswordModifyIcon';
import MisPagosIcon from '../../assets/images/MisPagosIcon';

export const UserMenu = () => {
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();
  const { nombre, apellido, username, flotas } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  const [modalPassword, setModalPassword] = useState({
    show: false,
    iduser: null,
  });

  const onLogout = () => {
    dispatch(startLogout());
  };

  return (
    <>
      {isMobile ? (
        <Dropdown className='user-options' align={{ lg: 'start' }}>
          <Dropdown.Toggle variant='user' id='dropdown-basic'>
            <UserIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu className='header-user-menu-mobile'>
            <Dropdown.Item>
              <div className='user-menu-mobile-title'>
                <div className='user-menu-mobile-username'>
                  {nombre?.toLowerCase()} {apellido?.toLowerCase()}
                </div>
                <div className='user-menu-mobile-email'>{username}</div>
              </div>
            </Dropdown.Item>
            <Dropdown.Divider className='hr-no-heigth' />
            <Dropdown.Item
              onClick={() =>
                setModalPassword({
                  show: true,
                  iduser: null,
                })
              }
            >
              <PasswordModifyIcon style={{ marginRight: '8px' }} />
              {t('header.user-menu.password')}
            </Dropdown.Item>
            <Dropdown.Divider className='hr-no-heigth' />
            <Dropdown.Item onClick={onLogout} className='logout-item'>
              <LogoutIcon style={{ marginRight: '8px' }} />
              {t('header.user-menu.salir')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Dropdown className='user-options' align={{ lg: 'end' }}>
          <Dropdown.Toggle variant='secondary' id='dropdown-basic'>
            <span className='user-item'>
              <UserIcon />
              <span className='username'>
                {nombre?.toLowerCase()} {apellido?.toLowerCase()}
              </span>
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className='header-user-menu'>
            <Dropdown.ItemText className='user-item-text'>
              <div className='user-menu-mobile-email'>{username}</div>
            </Dropdown.ItemText>
            <Dropdown.Divider className='hr-no-heigth' />
            {flotas === '1' && (
              <Dropdown.Item as={Link} to={getPath('fleetsHistory')}>
                <MisPagosIcon style={{ marginRight: '8px' }} />
                {t('header.user-menu.historial')}
              </Dropdown.Item>
            )}
            <Dropdown.Item
              onClick={() =>
                setModalPassword({
                  show: true,
                  iduser: null,
                })
              }
            >
              <PasswordModifyIcon style={{ marginRight: '8px' }} />
              {t('header.user-menu.password')}
            </Dropdown.Item>
            <Dropdown.Divider className='hr-no-heigth' />
            <Dropdown.Item onClick={onLogout} className='logout-item'>
              <LogoutIcon style={{ marginRight: '8px' }} />
              {t('header.user-menu.salir')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}

      <ModalCambiarPassword
        show={modalPassword.show}
        onHide={() => {
          setModalPassword({ show: false });
        }}
        iduser={modalPassword.iduser}
      />
    </>
  );
};
